import React, { useEffect, useMemo, useState } from 'react';
import client from '../api/client';
import ShareModal from '../components/ShareModal';
import '../App.css';

const SECTEURS = [
  'Industrie & production',
  'Commerce & distribution',
  'Banque, assurance & services financiers',
  'T\u00e9l\u00e9coms, IT & digital',
  'Transport, logistique & mobilit\u00e9',
  'BTP, immobilier & am\u00e9nagement',
  'Sant\u00e9, pharma & action sociale',
  '\u00c9ducation, conseil & services aux entreprises',
  'Tourisme, h\u00f4tellerie, restauration & loisirs',
  'Agriculture, \u00e9nergie & services publics',
  'Autre',
];

const COUNTRIES = [
  'Afghanistan','Afrique du Sud','Albanie','Alg\u00e9rie','Allemagne','Andorre',
  'Angola','Antigua-et-Barbuda','Arabie saoudite','Argentine','Arm\u00e9nie',
  'Australie','Autriche','Azerba\u00efdjan','Bahamas','Bahre\u00efn','Bangladesh',
  'Barbade','Belgique','Belize','B\u00e9nin','Bhoutan','Bi\u00e9lorussie','Birmanie',
  'Bolivie','Bosnie-Herz\u00e9govine','Botswana','Br\u00e9sil','Brunei','Bulgarie',
  'Burkina Faso','Burundi','Cambodge','Cameroun','Canada','Cap-Vert',
  'Centrafrique','Chili','Chine','Chypre','Colombie','Comores','Cor\u00e9e du Nord',
  'Cor\u00e9e du Sud','Costa Rica','C\u00f4te d\'Ivoire','Croatie','Cuba','Danemark',
  'Djibouti','Dominique','R\u00e9publique dominicaine','\u00c9gypte',
  '\u00c9mirats arabes unis','\u00c9quateur','\u00c9rythr\u00e9e','Espagne',
  'Estonie','Eswatini','\u00c9tats-Unis','\u00c9thiopie','Fidji','Finlande',
  'France','Gabon','Gambie','G\u00e9orgie','Ghana','Gr\u00e8ce','Grenade',
  'Guatemala','Guin\u00e9e','Guin\u00e9e-Bissau','Guin\u00e9e \u00e9quatoriale',
  'Guyana','Ha\u00efti','Honduras','Hongrie','Inde','Indon\u00e9sie','Irak','Iran',
  'Irlande','Islande','Isra\u00ebl','Italie','Jama\u00efque','Japon','Jordanie',
  'Kazakhstan','Kenya','Kirghizistan','Kiribati','Kowe\u00eft','Laos','Lesotho',
  'Lettonie','Liban','Liberia','Libye','Liechtenstein','Lituanie','Luxembourg',
  'Mac\u00e9doine du Nord','Madagascar','Malaisie','Malawi','Maldives','Mali',
  'Malte','Maroc','Maurice','Mauritanie','Mexique','Micronesie','Moldavie',
  'Monaco','Mongolie','Mont\u00e9n\u00e9gro','Mozambique','Namibie','Nauru',
  'N\u00e9pal','Nicaragua','Niger','Nigeria','Norv\u00e8ge','Nouvelle-Z\u00e9lande',
  'Oman','Ouganda','Ouzb\u00e9kistan','Pakistan','Palaos','Palestine','Panama',
  'Papouasie-Nouvelle-Guin\u00e9e','Paraguay','Pays-Bas','P\u00e9rou','Philippines',
  'Pologne','Portugal','Qatar','R\u00e9publique tch\u00e8que','Roumanie',
  'Royaume-Uni','Russie','Rwanda','Saint-Kitts-et-Nevis','Saint-Vincent-et-les-Grenadines',
  'Sainte-Lucie','Salomon','Salvador','Samoa','S\u00e3o Tom\u00e9-et-Pr\u00edncipe',
  'S\u00e9n\u00e9gal','Serbie','Seychelles','Sierra Leone','Singapour','Slovaquie',
  'Slov\u00e9nie','Somalie','Soudan','Soudan du Sud','Sri Lanka','Su\u00e8de',
  'Suisse','Suriname','Syrie','Tadjikistan','Tanzanie','Tchad','Tha\u00eflande',
  'Timor oriental','Togo','Tonga','Trinit\u00e9-et-Tobago','Tunisie','Turkm\u00e9nistan',
  'Turquie','Tuvalu','Ukraine','Uruguay','Vanuatu','Vatican','Venezuela',
  'Vi\u00eat Nam','Y\u00e9men','Zambie','Zimbabwe',
];

function ResultsList() {
  const [surveys, setSurveys] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedSurvey, setSelectedSurvey] = useState(null);

  // Form fields
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [secteur, setSecteur] = useState('');
  const [secteurAutre, setSecteurAutre] = useState('');
  const [pays, setPays] = useState('');
  const [paysFocused, setPaysFocused] = useState(false);

  const [lookupState, setLookupState] = useState('idle');
  const [generalData, setGeneralData] = useState(null);
  const [showContactModal, setShowContactModal] = useState(false);
  const [shareSurvey, setShareSurvey] = useState(null);
  const [pendingRedirect, setPendingRedirect] = useState(null);

  useEffect(() => {
    client
      .get('/chatbot/surveys')
      .then((res) => setSurveys(res.data?.data?.surveys || []))
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }, []);

  const filteredCountries = useMemo(() => {
    if (!pays.trim()) return [];
    const q = pays.toLowerCase().trim();
    return COUNTRIES.filter((c) => c.toLowerCase().includes(q)).slice(0, 8);
  }, [pays]);

  const showSuggestions = paysFocused && filteredCountries.length > 0;
  const resolvedSecteur = secteur === 'Autre' ? secteurAutre.trim() : secteur;

  const allFieldsFilled = name.trim() && email.trim() && resolvedSecteur && pays.trim();
  const [validationError, setValidationError] = useState('');

  const getStoredToken = (surveyId) => {
    try {
      const sessions = JSON.parse(localStorage.getItem('immersion_sessions') || '{}');
      return sessions[surveyId] || null;
    } catch { return null; }
  };

  const goToResults = (url) => {
    setPendingRedirect(url);
    setShowContactModal(true);
  };

  const handleModalClose = () => {
    setShowContactModal(false);
    if (pendingRedirect) {
      window.location.href = pendingRedirect;
    }
  };

  const handleSelectSurvey = async (survey) => {
    const storedToken = getStoredToken(survey.id);
    if (storedToken) {
      // Check if participant already has all info
      try {
        const res = await client.get('/chatbot/participant/info', { params: { token: storedToken } });
        const info = res.data?.data;
        if (info?.found && info?.complete) {
          // All info present → skip form, show contact modal then results
          goToResults(`/surveys/${survey.id}/results/${storedToken}`);
          return;
        }
        // Pre-fill form with existing info
        if (info?.found) {
          if (info.name && info.name !== 'Anonymous participant') setName(info.name);
          if (info.email) setEmail(info.email);
          if (info.secteur) setSecteur(info.secteur);
          if (info.pays) setPays(info.pays);
        }
      } catch { /* ignore, show form */ }
    }
    setSelectedSurvey(survey);
  };

  const handleLookup = async () => {
    if (!selectedSurvey) return;

    // Validate all fields
    if (!allFieldsFilled) {
      setValidationError('Veuillez remplir tous les champs pour continuer.');
      return;
    }
    setValidationError('');
    setLookupState('loading');

    // Save info to participant if we have a stored token
    const storedToken = getStoredToken(selectedSurvey.id);
    if (storedToken) {
      try {
        await client.post('/chatbot/participant/update', {
          token: storedToken,
          name: name.trim(),
          email: email.trim(),
          secteur: resolvedSecteur,
          pays: pays.trim(),
        });
      } catch { /* ignore */ }
      goToResults(`/surveys/${selectedSurvey.id}/results/${storedToken}`);
      return;
    }

    // Try lookup by info
    try {
      const res = await client.post('/chatbot/results/lookup', {
        survey_id: selectedSurvey.id,
        name: name.trim(),
        email: email.trim(),
        secteur: resolvedSecteur,
        pays: pays.trim(),
      });
      const data = res.data?.data;
      if (data?.found && data?.results_path) {
        goToResults(data.results_path);
        return;
      }
      goToResults(`/surveys/${selectedSurvey.id}/results/general`);
    } catch {
      setLookupState('idle');
    }
  };

  const handleBack = () => {
    setSelectedSurvey(null);
    setName('');
    setEmail('');
    setSecteur('');
    setSecteurAutre('');
    setPays('');
    setLookupState('idle');
    setGeneralData(null);
    setValidationError('');
  };

  return (
    <div className="landing">
      <header className="landing__hero">
        <img
          src={`${process.env.PUBLIC_URL}/IMMERSION CONSULTING GROUP NOIR.png`}
          alt="Immersion Consulting Group"
          className="page-logo"
        />
        <div className="landing__hero-content">
          <span className="landing__badge">Analyse</span>
          <h1 className="landing__title">
            {"Résultats des "}<em>sondages</em>
          </h1>
          <p className="landing__subtitle">
            {"Sélectionnez un sondage et renseignez vos informations pour voir vos résultats personnalisés, ou consultez les résultats généraux."}
          </p>
        </div>
      </header>

      <div className="landing__body">
        {/* ── Survey selection ─────────────────── */}
        {!selectedSurvey && (
          <>
            <div className="landing__section-header">
              <h2 className="landing__section-title">Sondages disponibles</h2>
              <div className="landing__section-line" />
            </div>

            {isLoading && (
              <div className="landing__grid">
                {[0, 1].map((i) => (
                  <div className="skeleton-card" key={i}>
                    <div className="skeleton-line skeleton-line--title" />
                    <div className="skeleton-line skeleton-line--text" />
                    <div className="skeleton-line skeleton-line--short" />
                  </div>
                ))}
              </div>
            )}

            {!isLoading && surveys.length === 0 && (
              <p className="landing__status landing__status--empty">
                Aucun sondage disponible.
              </p>
            )}

            {!isLoading && surveys.length > 0 && (
              <div className="landing__grid">
                {surveys.map((survey, i) => (
                  <article
                    className="survey-card"
                    key={survey.id}
                    style={{ animationDelay: `${0.3 + i * 0.08}s` }}
                  >
                    <h3 className="survey-card__title">{survey.title}</h3>
                    <p className="survey-card__desc">
                      {survey.description || 'Aucune description.'}
                    </p>
                    <div className="survey-card__footer">
                      <span className="survey-card__meta">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                        </svg>
                        {"Résultats"}
                      </span>
                      <button
                        type="button"
                        className="btn btn--primary"
                        onClick={() => handleSelectSurvey(survey)}
                      >
                        Consulter
                        <span className="btn__arrow">&rarr;</span>
                      </button>
                    </div>
                  </article>
                ))}
              </div>
            )}

            <div className="results-list__nav">
              <a href="https://immersionconsultinggroup.com/" className="btn btn--outline">Accueil</a>
              <a href="/surveys" className="btn btn--outline">Participer</a>
            </div>
          </>
        )}

        {/* ── Lookup form ─────────────────────── */}
        {selectedSurvey && lookupState !== 'general' && lookupState !== 'not_found' && (
          <>
            <button type="button" className="results-list__back" onClick={handleBack}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6" />
              </svg>
              Retour
            </button>

            <div className="landing__form">
              <h2 className="landing__form-title">{selectedSurvey.title}</h2>
              <p className="landing__form-hint">
                {"Renseignez vos informations pour accéder à vos résultats personnalisés."}
              </p>

              {validationError && (
                <p className="results-list__validation-error">{validationError}</p>
              )}

              <div className="landing__row">
                <div className="landing__field">
                  <label className="landing__label" htmlFor="lookup-name">Nom</label>
                  <input
                    id="lookup-name"
                    className="landing__input"
                    type="text"
                    placeholder="Mohammed Bennani"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="landing__field">
                  <label className="landing__label" htmlFor="lookup-email">Courriel</label>
                  <input
                    id="lookup-email"
                    className="landing__input"
                    type="email"
                    placeholder="Mohammed@exemple.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              <div className="landing__row">
                <div className="landing__field">
                  <label className="landing__label" htmlFor="lookup-secteur">
                    {"Secteur d\u2019activit\u00e9"}
                  </label>
                  <select
                    id="lookup-secteur"
                    className="landing__input landing__select"
                    value={secteur}
                    onChange={(e) => setSecteur(e.target.value)}
                  >
                    <option value="">{"S\u00e9lectionner\u2026"}</option>
                    {SECTEURS.map((s) => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                  {secteur === 'Autre' && (
                    <input
                      className="landing__input landing__input--autre"
                      type="text"
                      placeholder={"Pr\u00e9cisez votre secteur\u2026"}
                      value={secteurAutre}
                      onChange={(e) => setSecteurAutre(e.target.value)}
                    />
                  )}
                </div>

                <div className="landing__field landing__field--autocomplete">
                  <label className="landing__label" htmlFor="lookup-pays">Pays</label>
                  <input
                    id="lookup-pays"
                    className="landing__input"
                    type="text"
                    placeholder="Maroc"
                    value={pays}
                    onChange={(e) => setPays(e.target.value)}
                    onFocus={() => setPaysFocused(true)}
                    onBlur={() => setTimeout(() => setPaysFocused(false), 150)}
                    autoComplete="off"
                  />
                  {showSuggestions && (
                    <ul className="landing__suggestions">
                      {filteredCountries.map((c) => (
                        <li
                          key={c}
                          className="landing__suggestion"
                          onMouseDown={() => { setPays(c); setPaysFocused(false); }}
                        >
                          {c}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>

              <div className="results-list__actions">
                <button
                  type="button"
                  className="btn btn--primary"
                  onClick={handleLookup}
                  disabled={lookupState === 'loading'}
                >
                  {lookupState === 'loading' ? 'Recherche\u2026' : 'Voir les résultats'}
                  {lookupState !== 'loading' && <span className="btn__arrow">&rarr;</span>}
                </button>
              </div>
            </div>
          </>
        )}

        {/* General/not-found now redirects to /surveys/:id/results/general */}
      </div>

      {showContactModal && (
        <ContactModal onClose={handleModalClose} />
      )}

    </div>
  );
}

/* ── Contact Modal ─────────────────────────────────── */
function ContactModal({ onClose }) {
  const downloadVCard = () => {
    const vcard = [
      'BEGIN:VCARD',
      'VERSION:3.0',
      'N:Ouaratou;Yassine;;;',
      'FN:Yassine Ouaratou',
      'ORG:Immersion Consulting Group',
      'EMAIL:y.ouaratou@immersion.ma',
      'TEL;TYPE=CELL:+212 600-066127',
      'END:VCARD',
    ].join('\r\n');

    const blob = new Blob([vcard], { type: 'text/vcard;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Yassine_Ouaratou.vcf';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="modal__close" onClick={onClose}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className="modal__avatar">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        </div>

        <h2 className="modal__name">Yassine Ouaratou</h2>
        <p className="modal__company">Immersion Consulting Group</p>
        <img
          src={`${process.env.PUBLIC_URL}/immersion_group_new_logo.png`}
          alt="Immersion Consulting Group"
          className="modal__logo"
        />

        <div className="modal__details">
          <a href="mailto:y.ouaratou@immersion.ma" className="modal__detail">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
            y.ouaratou@immersion.ma
          </a>
          <a href="tel:+212600066127" className="modal__detail">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            +212 600-066127
          </a>
        </div>

        <div className="modal__actions">
          <button type="button" className="btn btn--primary modal__add-btn" onClick={downloadVCard}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="8.5" cy="7" r="4" />
              <line x1="20" y1="8" x2="20" y2="14" />
              <line x1="23" y1="11" x2="17" y2="11" />
            </svg>
            Ajouter aux contacts
          </button>
          <button type="button" className="btn btn--outline modal__skip-btn" onClick={onClose}>
            Continuer
            <span className="btn__arrow">&rarr;</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ResultsList;
